import React from "react";

function Videos() {
  return <div>Yay Videos!</div>;
}
export default Videos;
